<template>
  <v-dialog :value="!!conflicts" max-width="520" scrollable persistent content-class="ds-wizard-dialog" @keydown.esc="decide('cancel')">
    <v-card v-if="conflicts" class="ds-dialog">
      <div class="ds-dialog__header">
        <div class="ds-dialog__header-icon">
          <v-icon color="warning">mdi-swap-horizontal</v-icon>
        </div>
        <div class="ds-dialog__header-text">
          <span class="ds-dialog__title">Replace zone {{ conflicts.length === 1 ? 'assignment' : 'assignments' }}?</span>
          <span class="ds-dialog__subtitle">These zone types allow only one zone per record</span>
        </div>
      </div>
      <v-card-text class="replace-body">
        <div v-for="conflict in conflicts" :key="conflict.recordType + conflict.recordId + conflict.zoneId" class="replace-row">
          <div class="font-weight-medium">{{ conflict.recordName }}</div>
          <div class="caption">{{ conflict.zoneTypeName }}</div>
          <div class="d-flex align-center flex-wrap mt-1" style="gap: 6px">
            <v-chip v-for="link in conflict.existing" :key="link.assignmentId" x-small outlined>
              {{ link.zoneName }}<span v-if="link.zoneStatus === 'retired'">&nbsp;(retired)</span>
            </v-chip>
            <v-icon small>mdi-arrow-right</v-icon>
            <v-chip x-small color="primary" text-color="white">{{ conflict.zoneName }}</v-chip>
          </div>
        </div>
      </v-card-text>
      <div class="ds-dialog__footer">
        <span class="ds-dialog__hint">Replacing removes the current assignment. Nothing changes until you choose.</span>
        <v-spacer />
        <v-btn text @click="decide('cancel')">Cancel</v-btn>
        <v-btn v-if="canSkip" text @click="decide('skip')">Keep current</v-btn>
        <v-btn color="primary" depressed @click="decide('replace')">Replace</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * The explicit replacement decision for one-zone-only zone types (AVA-764): an assignment that would
   * give a record a second zone of such a type is never made silently. `ask(conflicts, { canSkip })`
   * resolves to 'replace', 'skip' (assign only the rest) or 'cancel'.
   */
  export default {
    name: 'ZoneReplaceDialog',
    data() {
      return { conflicts: null, canSkip: false, resolve: null };
    },
    methods: {
      ask(conflicts, { canSkip = false } = {}) {
        this.decide('cancel');
        this.conflicts = conflicts;
        this.canSkip = canSkip;
        return new Promise((resolve) => {
          this.resolve = resolve;
        });
      },
      decide(choice) {
        const resolve = this.resolve;
        this.resolve = null;
        this.conflicts = null;
        if (resolve) resolve(choice);
      },
    },
  };
</script>

<style scoped lang="scss">
  .replace-body {
    max-height: 360px;
    padding: var(--ds-space-md) var(--ds-space-lg) !important;
  }

  .replace-row {
    padding: var(--ds-space-sm) 0;
    border-bottom: 1px solid var(--v-bg7-base);

    &:last-child {
      border-bottom: 0;
    }
  }
</style>
